<template>
    <div class="hiq-public-art__gallery" ref="grid">
        <art-item v-for="(item, i) in items" :key="item.id" :item="item" :imageClass="getImageClass(i)"></art-item>
    </div>
</template>

<script>
import ArtItem from './ArtItem.vue';
import Masonry from 'masonry-layout';
import ImagesLoaded from 'imagesloaded';
export default {
    name: 'art-list',
    data() {
        return {
            masonry: null,
        }
    },
    computed: {
        items() {
            return this.$store.state.art.items;
        }
    },
    methods: {
        getImageClass(i) {
            const classes = ['high', 'low', 'higher', 'lower', 'medium'];
            return classes[i%classes.length];
        }
    },
    watch: {
        items(newVal) {
            this.$nextTick(() => {
                ImagesLoaded(this.$refs.grid, () => {
                    this.masonry.reloadItems();
                    this.masonry.layout();
                })
            })
        }
    },
    components: {
        ArtItem
    },
    mounted() {
        const grid = this.$refs.grid;
        const itemSelector = '.hiq-public-art__item';
        // ImagesLoaded(grid, () => {
        //     this.masonry = new Masonry(grid, {
        //         columnWidth: itemSelector,
        //         itemSelector: itemSelector,
        //         gutter: 30,
        //         horizontalOrder: true,
        //         percentPosition: true,
        //     });
        //     const item = document.querySelector(itemSelector);
        //     if(item) {
        //         const resizeObserver = new ResizeObserver(entries => {
        //             this.masonry.layout();
        //         });
        //         resizeObserver.observe(item);
        //     }
        // });
    }
}
</script>